/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowcaseEntry } from './ShowcaseEntry';
import {
    ShowcaseEntryFromJSON,
    ShowcaseEntryFromJSONTyped,
    ShowcaseEntryToJSON,
    ShowcaseEntryToJSONTyped,
} from './ShowcaseEntry';

/**
 * 
 * @export
 * @interface ShowcaseSubmitResponse
 */
export interface ShowcaseSubmitResponse {
    /**
     * 
     * @type {ShowcaseEntry}
     * @memberof ShowcaseSubmitResponse
     */
    entry: ShowcaseEntry;
    /**
     * 
     * @type {number}
     * @memberof ShowcaseSubmitResponse
     */
    totalSubmissions: number;
}

/**
 * Check if a given object implements the ShowcaseSubmitResponse interface.
 */
export function instanceOfShowcaseSubmitResponse(value: object): value is ShowcaseSubmitResponse {
    if (!('entry' in value) || value['entry'] === undefined) return false;
    if (!('totalSubmissions' in value) || value['totalSubmissions'] === undefined) return false;
    return true;
}

export function ShowcaseSubmitResponseFromJSON(json: any): ShowcaseSubmitResponse {
    return ShowcaseSubmitResponseFromJSONTyped(json, false);
}

export function ShowcaseSubmitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowcaseSubmitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entry': ShowcaseEntryFromJSON(json['entry']),
        'totalSubmissions': json['totalSubmissions'],
    };
}

export function ShowcaseSubmitResponseToJSON(json: any): ShowcaseSubmitResponse {
    return ShowcaseSubmitResponseToJSONTyped(json, false);
}

export function ShowcaseSubmitResponseToJSONTyped(value?: ShowcaseSubmitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entry': ShowcaseEntryToJSON(value['entry']),
        'totalSubmissions': value['totalSubmissions'],
    };
}

